<template>
  <div class="app-container">
    <list ref="list" @type-change="typeChange" @change="onChange" @reload="reload">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
          <el-button
            size="mini"
            type="primary"
            @click="check"
            icon="el-icon-plus"
            >添加</el-button
          >
          <el-button
            size="mini"
            class="filter-item"
            type="danger"
            @click="delRows"
            >删除</el-button
          >
      </template>
    </list>
       <div class="list-head" style="margin-top: 10px;">
      <span v-if="type==0">收款单明细</span>
      <span v-else>付款单明细</span>
    </div>
    <el-table class="tb-c-head" border :data="Details1" v-loading="loading1" show-summary>
      <el-table-column label="单据日期" min-width="120">
        <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
      </el-table-column>
      <el-table-column label="单据编号" min-width="150" show-overflow-tooltip>
        <template slot-scope="{row}">{{row.DocNo}}</template>
      </el-table-column>
      <el-table-column label="往来单位" min-width="150">
        <template slot-scope="{row}">{{row.TradeUnitName}}</template>
      </el-table-column>
      <!-- <el-table-column label="部门" min-width="100">
          <template slot-scope="{row}">{{row.DpName}}</template>
      </el-table-column>-->
      <el-table-column label="经办人" min-width="100">
        <template slot-scope="{row}">{{row.ClerkName}}</template>
      </el-table-column>
      <el-table-column prop="Amount" label="金额" width="120" />
      <el-table-column prop="NoSettleAmount" label="应核销金额" width="120" />
      <el-table-column prop="WriteoffAmount" label="本次销金额" width="120" />
      <!-- <el-table-column prop="TotalAmount" label="累计销金额" width="120" /> -->
    </el-table>
    <div class="list-head" style="margin-top: 10px;">
      <span>核销明细</span>
    </div>
    <el-table class="tb-c-head" border :data="Details2" v-loading="loading2" show-summary>
      <el-table-column label="单据类型" min-width="80">
        <template slot-scope="{row}">{{row.SourceTypeName}}</template>
      </el-table-column>
      <el-table-column label="单据日期" min-width="100">
        <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
      </el-table-column>
      <el-table-column label="单据编号" min-width="150" show-overflow-tooltip>
        <template slot-scope="{row}">{{row.DocNo}}</template>
      </el-table-column>
      <el-table-column label="往来单位" min-width="150">
        <template slot-scope="{row}">{{row.TradeUnitName}}</template>
      </el-table-column>
      <!-- <el-table-column label="部门" min-width="90">
          <template slot-scope="{row}">{{row.DpName}}</template>
      </el-table-column>-->
      <el-table-column label="经办人" min-width="90">
        <template slot-scope="{row}">{{row.ClerkName}}</template>
      </el-table-column>
      <el-table-column prop="Amount" label="金额" width="120" />
      <el-table-column prop="NoSettleAmount" label="应核销金额" width="120" />
      <el-table-column prop="WriteoffAmount" label="本次销金额" width="120" />
    </el-table>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <check-dialog ref="checkDialog" @close-saved="reload" @confirm="create" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/fund/contactcash/writeoff/list";
import editDialog from "@/components/fund/contactcash/writeoff/editDialog";
import checkDialog from "@/components/fund/contactcash/writeoff/checkDialog";
export default {
  name: "receipt",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    checkDialog
  },
  data() {
    return {
      rp_api: require("@/api/fund/contactcash/woDocRp").default,
      wo_api: require("@/api/fund/contactcash/woDocWo").default,
      Details1: [], //收/付款单明细
      Details2: [], //核销明细
      loading1: false,
      loading2: false,
      type: 0,
    }
  },
  methods: {
        reload() {
      this.$refs.list.reload();
      this.Details1 = [];
      this.Details2 = [];
    },
    onChange(row) {
      
      this.Details1 = [];
      this.Details2 = [];
      this.loading1 = true;
      this.rp_api.list({ WoDocID: row.WoDocId }).then((res) => {
        this.loading1 = false;
        if (res.Code == 0) this.Details1 = res.Data;
      });
      this.loading2 = true;
      this.wo_api.list({ WoDocID: row.WoDocId }).then((res) => {
        this.loading2 = false;
        if (res.Code == 0) this.Details2 = res.Data;
      });
    },
    typeChange(type) {
      this.type = type;
      this.Details1 = [];
      this.Details2 = [];
    },
    check(){
        this.$refs.checkDialog.openCreate();
    },
    create(data){
        
         this.$refs.editDialog.openCreate(data);
    },
    delRows(id) {
    this.$confirm("确认删除数据吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.api.delete(id).then(res => {
          if(res.Code ==0) {
            this.$message.success("删除成功")
            this.$refs.list.reload();
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
      .catch(() => {});
    },
  },
};
</script>